import React, { useEffect, useState } from "react";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/NewIcons/IconDownloadWhie.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/NewIcons/exitIcon.svg";
import certificateImg from "../../../assets/images/Phase3Template.jpg";
import ShareCertiWithSocialmedia from "../ShareCertiWithSocialmedia";
import DownloadCertificateMenu from "../DownloadCertificate/DownloadCertificateMenu";
import "./Stage3Cetificate.scss";
const Stage3Certificate = ({ data, publicShareTrue }) => {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true); // Open modal
    setImageLoaded(false); // Reset imageLoaded for new modal
  };

  const handleClose = () => {
    setOpen(false); // Close modal
    setSelectedCertificate(null);
  };

  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <>
      {!publicShareTrue && (
        <div className="stage3certificateSmallerContainer">
          <div className="certificateSmallerWrapper">
            <div key={certificate.id} className="small_certificate_container">
              <div className="topSection">
                <DownloadCertificateMenu
                  name={certificate?.name}
                  icon={<DownloadIcon />}
                  // The artwork only exists inside the modal, so open it first.
                  onBeforeDownload={() => handleOpen(certificate)}
                />
                <div className="certificateTitle">
                  <h3 className="certificate_title">{certificate?.title}</h3>
                </div>
              </div>
              <div className="certificateImgContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="small_certificate_image"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen(certificate)} // Open modal when certificate image is clicked
                />
                <div className="small_certificate_name">
                  {certificate?.name}
                </div>
                <div className="small_certificate_date">
                  {certificate?.created_at}
                </div>{" "}
              </div>
              <div
                className="frame-btn-container"
                style={{ marginTop: "10px", textAlign: "center" }}
              >
                <a
                  href="https://fundedaward.com/products/ac-award?ta_aff=capital"
                  target="_blank"
                  rel="noreferrer"
                  className="frame-certificate-btn"
                >
                  Frame Certificate
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Section */}
      {(open || publicShareTrue) && (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } stage3certificateCardOverlay`}
          onClick={handleClose}
        >
          {" "}
          <div
            className="certificateCardContainer"
            onClick={(e) => e.stopPropagation()} // Prevent click on container from closing modal
          >
            <div className="certificateCardWrapper">
              <div className="certificateDetail certificatePopModalHeader">
                <div className="topSection">
                  <div className="certificateTitle">
                    <p>{selectedCertificate?.title}</p>
                  </div>
                </div>
                <div className="bottomSection">
                  <DownloadCertificateMenu
                    name={selectedCertificate?.name}
                    icon={<DownloadIcon />}
                  />
                  {!publicShareTrue && (
                    <div className="rightSection">
                      <ShareCertiWithSocialmedia data={selectedCertificate} />

                      <div className="crossBtn">
                        <CrossIcon onClick={handleClose} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="certificateImage" id="certificateContainer">
                <img
                  src={certificateImg}
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)} // Set imageLoaded flag to true after the image is loaded
                />
                {imageLoaded && (
                  <>
                    <div className="certificateReceiver">
                      <p>{selectedCertificate?.name}</p>
                    </div>
                    <div className="certificateIssueDate">
                      <p>{selectedCertificate?.created_at}</p>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Stage3Certificate;
